import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';

const Footer = ({ className = '' }) => {
  return (
    <footer className={`bg-[#0f1419] text-white pb-20 lg:pb-0 ${className}`}>
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4">Erimli Belediyesi</h3>
            <p className="text-gray-400 text-sm mb-4">
              İnsanı merkeze alan, adil, şeffaf ve katılımcı bir yönetim anlayışıyla çalışıyoruz.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/erimlibelediye/?locale=tr_TR" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-[#2171b5] flex items-center justify-center hover:bg-[#1e5a8e] transition">
                <Facebook size={18} aria-hidden="true" />
              </a>
              <a href="https://x.com/erimlibelediyesi" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)" className="w-10 h-10 rounded-full bg-[#2171b5] flex items-center justify-center hover:bg-[#1e5a8e] transition">
                <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16" aria-hidden="true">
                  <path d="M18.901 3H22.5L14.477 12.026L23.75 24H16.526L10.743 16.596L4.125 24H0.526L9.049 14.373L0.053 3H7.476L12.756 9.946L18.901 3ZM17.653 21.829H19.645L6.426 5.021H4.29L17.653 21.829Z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/erimli.belediyesi/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full bg-[#2171b5] flex items-center justify-center hover:bg-[#1e5a8e] transition">
                <Instagram size={18} aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Hızlı Erişim</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/haberler" className="text-gray-400 hover:text-white transition">Haberler</Link></li>
              <li><Link to="/duyurular" className="text-gray-400 hover:text-white transition">Duyurular</Link></li>
              <li><Link to="/etkinlikler" className="text-gray-400 hover:text-white transition">Etkinlikler</Link></li>
              <li><Link to="/ihaleler" className="text-gray-400 hover:text-white transition">İhaleler</Link></li>
              <li><Link to="/projeler" className="text-gray-400 hover:text-white transition">Projeler</Link></li>
              <li><Link to="/foto-galeri" className="text-gray-400 hover:text-white transition">Fotoğraf Galerisi</Link></li>
              <li><Link to="/sss" className="text-gray-400 hover:text-white transition">Sıkça Sorulan Sorular</Link></li>
              <li><Link to="/yardim" className="text-gray-400 hover:text-white transition">Yardım</Link></li>
            </ul>
          </div>

          {/* Logo - Center */}
          <div className="flex items-center justify-center md:col-span-1 lg:col-span-1">
            <Link to="/" className="flex items-center justify-center">
              <img
                src="/logo.png?v=4"
                alt="Erimli Belediyesi Logo"
                width={200}
                height={200}
                loading="lazy"
                decoding="async"
                className="w-[200px] h-[200px] object-contain drop-shadow-2xl"
              />
            </Link>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">Hizmetlerimiz</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/hizmet-rehberi" className="text-gray-400 hover:text-white transition">Hizmet Rehberi</Link></li>
              <li><Link to="/mevzuat" className="text-gray-400 hover:text-white transition">Mevzuat</Link></li>
              <li><Link to="/bilgi-edinme" className="text-gray-400 hover:text-white transition">Bilgi Edinme Hakkı</Link></li>
              <li><Link to="/sikayet-ve-geri-bildirim" className="text-gray-400 hover:text-white transition">Şikayet ve Geri Bildirim</Link></li>
              <li><Link to="/kurumsal" className="text-gray-400 hover:text-white transition">Hakkımızda</Link></li>
              <li><Link to="/birimler" className="text-gray-400 hover:text-white transition">Birimlerimiz</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-4">İletişim</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span>Cami Mah. Merkez Küme Evleri No:59 Kat:2<br />Arıcak / Elazığ</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Phone size={18} className="flex-shrink-0" />
                <span>0424 781 40 03</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Mail size={18} className="flex-shrink-0" />
                <span>info@erimli.bel.tr</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>&copy; 2026 Erimli Belediyesi. Tüm hakları saklıdır.</p>
            <a
              href="https://utechcy.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white transition"
            >
              <span className="text-sm">Bu site</span>
              <img
                src="/images/ute-logo-v2.png"
                alt="UTE Technology Solutions"
                loading="lazy"
                decoding="async"
                className="h-16 object-contain"
              />
              <span className="text-sm">tarafından yapılmıştır</span>
            </a>
            <div className="flex gap-6">
              <Link to="/gizlilik-politikasi" className="hover:text-white transition">Gizlilik Politikası</Link>
              <Link to="/kullanim-kosullari" className="hover:text-white transition">Kullanım Koşulları</Link>
              <Link to="/admin" className="hover:text-white transition">Yönetim Paneli</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
